import React, { useCallback, useEffect } from 'react'
import { PaletteMode, ThemeProvider as MuiThemeProvider } from '@mui/material'

import { useLocalStorage } from '../../hooks'
import { ThemeContext } from '../../contexts'

import { getModuleTheme } from './theme.tsx'

export const ThemeProvider = ({ children }: React.PropsWithChildren<unknown>): React.ReactElement => {
  const prefersDarkMedia = window.matchMedia('(prefers-color-scheme: dark)')
  // проверяем тему, если в localStorage пусто - складываем тему системы
  const [theme, setTheme] = useLocalStorage('theme', prefersDarkMedia.matches ? 'dark' : 'light')

  const mediaListener = useCallback((event: MediaQueryListEvent) => {
    const nextTheme: PaletteMode = event.matches ? 'dark' : 'light'
    setTheme(nextTheme)
  }, [])

  useEffect(() => {
    prefersDarkMedia.addListener(mediaListener)

    return () => {
      prefersDarkMedia.removeListener(mediaListener)
    }
  }, [])

  // https://mui.com/material-ui/customization/dark-mode/
  return (
    <MuiThemeProvider theme={getModuleTheme(theme)}>
      <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
    </MuiThemeProvider>
  )
}
